import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TopbarService {
  private registerCallSource = new Subject<void>();
  private signedInCallSource = new Subject<void>();
  private forgotPasswordCallSource = new Subject<void>();
  registerCalled$ = this.registerCallSource.asObservable();
  signedInCallSource$ = this.signedInCallSource.asObservable();
  forgotPasswordCalled$ = this.forgotPasswordCallSource.asObservable();

  callRegister() {
    this.registerCallSource.next();
  }

  callSignIn() {
    this.signedInCallSource.next();
  }

  callForgotPassword() {
    this.forgotPasswordCallSource.next();
  }
}
